// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z8hQmZEQQhN92G {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: var(--ds-background-warning, #fff7d6);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 22px;
  text-align: center;
  word-wrap: break-word;
}
.NhkjvgN38wl12l {
  width: calc(100% - 100px);
}
.LsvtFLUww9Pmeg {
  color: var(--ds-text-subtle, #44546f);
}
.D_rC79VeZeCmZa {
  position: absolute;
  top: 8px;
  right: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningBanner": `Z8hQmZEQQhN92G`,
	"bannerMessage": `NhkjvgN38wl12l`,
	"billingLink": `LsvtFLUww9Pmeg`,
	"close": `D_rC79VeZeCmZa`
};
export default ___CSS_LOADER_EXPORT___;
